import Renderer from "@wielink/datatables/Renderers/Renderer";

class AssetableActionRenderer extends Renderer {
	render() {
		let fileHtml = '';
		let previewUrl = this.config.previewUrl;
		for(let key in this.row) {
			previewUrl = previewUrl.replace(`_${key}_`, this.row.id);
			fileHtml = `
				<a href="${previewUrl}" class="btn btn-sm btn-dark" target="_blank">
					<i class="bi bi-eye"></i>
				</a>
			`;
		}

		return `
			<div class="d-inline-flex gap-2">
				<button data-model-id="${this.row.id}" data-dt-btn="openEditModal" class="btn btn-sm btn-success" aria-label="Bewerken" title="Bewerken">
					<i class="bi bi-pencil-square" style="pointer-events: none"></i>
				</button>
				<button data-dt-btn="delete" data-id="${this.row.id}" class="btn btn-sm btn-danger" aria-label="Verwijderen" title="Verwijderen">
					<i class="bi bi-trash3-fill"></i>
				</button>
				` + fileHtml + `
			</div>
		`
	}
}

export default AssetableActionRenderer;
